'use strict';

/////////////////////////////////////////////////
/////////////////////////////////////////////////
// BANKIST APP

/////////////////////////////////////////////////
// Data

// DIFFERENT DATA! Contains movement dates, currency and locale

const account1 = {
  owner: 'Jonas Schmedtmann',
  movements: [200, 455.23, -306.5, 25000, -642.21, -133.9, 79.97, 1300],
  interestRate: 1.2, // %
  pin: 1111,

  movementsDates: [
    '2019-11-18T21:31:17.178Z',
    '2019-12-23T07:42:02.383Z',
    '2020-01-28T09:15:04.904Z',
    '2020-04-01T10:17:24.185Z',
    '2020-05-08T14:11:59.604Z',
    '2020-05-27T17:01:17.194Z',
    '2024-07-11T23:36:17.929Z',
    '2024-07-13T10:51:36.790Z',
  ],
  currency: 'EUR',
  locale: 'pt-PT', // de-DE
};

const account2 = {
  owner: 'Jessica Davis',
  movements: [5000, 3400, -150, -790, -3210, -1000, 8500, -30],
  interestRate: 1.5,
  pin: 2222,

  movementsDates: [
    '2019-11-01T13:15:33.035Z',
    '2019-11-30T09:48:16.867Z',
    '2019-12-25T06:04:23.907Z',
    '2020-01-25T14:18:46.235Z',
    '2020-02-05T16:33:06.386Z',
    '2020-04-10T14:43:26.374Z',
    '2020-06-25T18:49:59.371Z',
    '2020-07-26T12:01:20.894Z',
  ],
  currency: 'USD',
  locale: 'en-US',
};

const accounts = [account1, account2];

const currExchange = [
  {
    from: 'USD',
    to: [
      { cur: 'EUR', rate: 0.9091 },
      { cur: 'BRL', rate: 0.1818 },
    ],
  },
  {
    from: 'EUR',
    to: [
      { cur: 'USD', rate: 1.1 },
      { cur: 'BRL', rate: 0.1652 },
    ],
  },
  {
    from: 'BRL',
    to: [
      { cur: 'USD', rate: 5.5 },
      { cur: 'EUR', rate: 6.05 },
    ],
  },
];

/////////////////////////////////////////////////
// Elements
const labelWelcome = document.querySelector('.welcome');
const labelDate = document.querySelector('.date');
const labelBalance = document.querySelector('.balance__value');
const labelSumIn = document.querySelector('.summary__value--in');
const labelSumOut = document.querySelector('.summary__value--out');
const labelSumInterest = document.querySelector('.summary__value--interest');
const labelLoan = document.querySelector('.summary__value--loan');
const labelMaxLoan = document.querySelector('.summary__value--maxloan');
const labelTimer = document.querySelector('.timer');
const labelLoanMessage = document.querySelector('.form__label--loanMessage');

const containerApp = document.querySelector('.app');
const containerMovements = document.querySelector('.movements');

const btnLogin = document.querySelector('.login__btn');
const btnTransfer = document.querySelector('.form__btn--transfer');
const btnLoan = document.querySelector('.form__btn--loan');
const btnClose = document.querySelector('.form__btn--close');
const btnSort = document.querySelector('.btn--sort');

const inputLoginUsername = document.querySelector('.login__input--user');
const inputLoginPin = document.querySelector('.login__input--pin');
const inputTransferTo = document.querySelector('.form__input--to');
const inputTransferAmount = document.querySelector('.form__input--amount');
const inputLoanAmount = document.querySelector('.form__input--loan-amount');
const inputCloseUsername = document.querySelector('.form__input--user');
const inputClosePin = document.querySelector('.form__input--pin');

const displayMovements = function (account, sort = false) {
  containerMovements.innerHTML = '';
  const movements = sort
    ? account.movements.slice().sort((a, b) => a - b)
    : account.movements;
  movements.forEach(function (mov, i) {
    let type;
    const displayDate = formatDate(
      new Date(account.movementsDates[i]),
      false,
      account.locale,
      true
    );
    if (account.loans?.includes(i)) type = mov > 0 ? 'loan' : 'payment';
    else type = mov > 0 ? 'deposit' : 'withdrawal';
    const html = `
        <div class="movements__row">
          <div class="movements__type movements__type--${type}">${
      i + 1
    } ${type}</div>
          <div class="movements__date">${displayDate}</div>
          <div class="movements__value">${formatCurrencyAmount(
            mov,
            account.locale,
            account.currency
          )}</div>
        </div>
    `;
    containerMovements.insertAdjacentHTML('afterbegin', html);
  });
};

const createUserNames = function (accs) {
  accounts.forEach(function (acc) {
    acc.username = acc.owner
      .toLowerCase()
      .split(' ')
      .map((word) => word[0])
      .join('');
  });
};

const calcDisplayBalance = function (account) {
  account.balance = account.movements.reduce((acc, cur) => acc + cur, 0);
  labelBalance.textContent = `${formatCurrencyAmount(
    account.balance,
    account.locale,
    account.currency
  )}`;
};

const calcDisplaySummary = function (account) {
  const deposit = (mov) => mov > 0;
  const expense = (mov) => mov < 0;
  const accumulate = (acc, mov) => acc + mov;
  const incomes = +account.movements.filter(deposit).reduce(accumulate, 0);
  const expenses = +account.movements.filter(expense).reduce(accumulate, 0);
  const interest = +account.movements
    .filter(deposit)
    .map((mov) => (mov * account.interestRate) / 100)
    .filter((int) => int >= 1)
    .reduce(accumulate, 0);
  const largestDeposit = +account.movements
    // filters only positive amounts that are not loans
    .filter((mov, i) => !account.loans?.includes(i) && mov > 0)
    // accumulates the largest amount found
    .reduce((acc, mov) => (acc > mov ? acc : mov), account.movements[0]);
  // Calculate MaxLoan
  if (!account.loan) account.loan = 0;
  account.maxLoan = 10 * largestDeposit - account.loan;

  labelSumIn.textContent = `${formatCurrencyAmount(
    incomes,
    account.locale,
    account.currency
  )}`;
  labelSumOut.textContent = `${formatCurrencyAmount(
    Math.abs(expenses),
    account.locale,
    account.currency
  )}`;
  labelSumInterest.textContent = `${formatCurrencyAmount(
    interest,
    account.locale,
    account.currency
  )}`;
  labelLoan.textContent = `${formatCurrencyAmount(
    account.loan,
    account.locale,
    account.currency
  )}`;
  labelMaxLoan.textContent = `${formatCurrencyAmount(
    account.maxLoan,
    account.locale,
    account.currency
  )}`;
};

const calcDaysPassed = (date1, date2) =>
  Math.round((date2 - date1) / (1000 * 60 * 60 * 24));

const formatDate = function (date, includeTime, locale, friendly = false) {
  // const day = `${date.getDate()}`.padStart(2, '0');
  // const month = `${date.getMonth() + 1}`.padStart(2, '0');
  // const year = date.getFullYear();
  // const hour = date.getHours();
  // const min = `${date.getMinutes()}`.padStart(2, '0');
  let options;
  if (includeTime) {
    options = {
      hour: 'numeric',
      minute: 'numeric',
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      // weekday: 'long',
    };
  } else {
    options = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      // weekday: 'long',
    };
  }

  if (!friendly)
    return new Intl.DateTimeFormat(locale, options).format(new Date());
  else {
    const daysPassed = calcDaysPassed(date, new Date());
    //console.log(daysPassed);
    switch (daysPassed) {
      case 0:
        return 'Today';
        break;
      case 1:
        return 'Yesterday';
        break;
      default:
        if (daysPassed > 10)
          return new Intl.DateTimeFormat(locale, options).format(new Date());
        else return `${daysPassed} days ago`;
    }
  }
};

const exchange = function (amount, from, to) {
  // const fromObj = ;
  // console.log(fromObj);
  return (
    amount *
    currExchange
      .find((cur) => cur.from === from)
      .to.find((cur) => cur.cur === to).rate
  );
};

const formatCurrencyAmount = function (amount, locale, currency) {
  const options = {
    style: 'currency',
    currency: currency,
  };
  return new Intl.NumberFormat(locale, options).format(amount);
};

const updateUI = function (account) {
  displayMovements(account);
  calcDisplayBalance(account);
  calcDisplaySummary(account);
};
const clearTransfer = function () {
  inputTransferTo.value = inputTransferAmount.value = '';
  if (logoutTimer) clearInterval(logoutTimer);
  logoutTimer = startLogoutTimer();
};
const clearClose = function () {
  inputCloseUsername.value = inputClosePin.value = '';
  currentAccount = null;
  containerApp.style.opacity = 0;
  labelWelcome.textContent = 'Your account has been closed.';
};
const clearLoanMessage = function () {
  labelLoanMessage.textContent = '';
};

const transferMoney = function (account1, account2, amount) {
  const now = new Date();
  account1.movements.push(-amount);
  account1.movementsDates.push(now.toISOString());
  account2.movements.push(
    exchange(amount, account1.currency, account2.currency)
  );
  account2.movementsDates.push(now.toISOString());
  updateUI(currentAccount);
  inputLoginPin.blur();
  inputLoginUsername.blur();
};

const startLogoutTimer = function () {
  const tick = function () {
    const min = Math.trunc(time / 60) + '';
    const sec = (time % 60) + '';
    labelTimer.textContent = `${min.padStart(2, '0')}:${sec.padStart(2, '0')}`;
    if (time-- === 0) {
      currentAccount = null;
      containerApp.style.opacity = 0;
      labelWelcome.textContent = 'Your session has timed out.';
      clearInterval(logoutTimer);
    }
  };
  let time = 300;
  tick();
  const logoutTimer = setInterval(tick, 1000);
  return logoutTimer;
};

//console.log(accounts);
createUserNames(accounts);
let currentAccount;

// //FAKE ALWAYS LOGGED IN
// currentAccount = account1;
// updateUI(currentAccount);
// containerApp.style.opacity = 100;
// labelDate.textContent = formatDate(
//   new Date(),
//   true,
//   currentAccount.locale,
//   false
// );
let sorted = false;
let logoutTimer;
btnLogin.addEventListener('click', function (e) {
  //prevent form from submitting
  e.preventDefault();
  currentAccount = accounts.find(
    (acc) => acc.username === inputLoginUsername.value
  );
  console.log(currentAccount);
  if (currentAccount?.pin === Number(inputLoginPin.value)) {
    labelWelcome.textContent = `Welcome back, ${
      currentAccount.owner.split(' ')[0]
    }`;
    labelWelcome.classList.remove('error');
    updateUI(currentAccount);
    containerApp.style.opacity = 100;
    inputLoginUsername.value = inputLoginPin.value = '';
    inputLoginPin.blur();
    inputLoginUsername.blur();
    labelDate.textContent = formatDate(
      new Date(),
      true,
      currentAccount.locale,
      false
    );
    if (logoutTimer) clearInterval(logoutTimer);
    logoutTimer = startLogoutTimer();
  } else {
    labelWelcome.textContent = 'Invalid credentials';
    labelWelcome.classList.add('error');
    containerApp.style.opacity = 0;
  }
});

btnTransfer.addEventListener('click', function (e) {
  //prevent form from submitting
  e.preventDefault();
  const amount = Number(inputTransferAmount.value);
  const toAccount = accounts.find(
    (acc) => acc.username === inputTransferTo.value
  );
  if (
    amount > 0 &&
    toAccount &&
    currentAccount.balance >= amount &&
    toAccount?.username !== currentAccount.username
  )
    transferMoney(currentAccount, toAccount, amount);
  clearTransfer();
});

btnClose.addEventListener('click', function (e) {
  //prevent form from submitting
  e.preventDefault();
  if (
    currentAccount.username === inputCloseUsername.value &&
    currentAccount.pin === Number(inputClosePin.value)
  ) {
    const index = accounts.findIndex(
      (acc) => acc.username === currentAccount.username
    );
    //console.log(index);
    accounts.splice(index, 1);
  }
  clearClose();
});

btnLoan.addEventListener('click', function (e) {
  //prevent form from submitting
  e.preventDefault();
  if (!currentAccount.loan) {
    currentAccount.loan = 0;
    currentAccount.loans = [];
  }
  const requestedLoan = Math.floor(inputLoanAmount.value);
  if (
    //loan must be below maxloan
    (requestedLoan > 0 && requestedLoan < currentAccount.maxLoan) ||
    //payment must be below currentloan
    (requestedLoan < 0 && Math.abs(requestedLoan) <= currentAccount.loan)
  ) {
    if (requestedLoan > 0) labelLoanMessage.textContent = 'Awaiting approval';
    const loanTimeout = setTimeout(
      function () {
        console.log(currentAccount);
        console.log(requestedLoan);
        const now = new Date();
        currentAccount.loan = currentAccount.loan + requestedLoan;
        currentAccount.maxLoan -= requestedLoan;
        currentAccount.movements.push(requestedLoan);
        currentAccount.movementsDates.push(now.toISOString());
        labelLoanMessage.classList.remove('error');
        currentAccount.loans.push(currentAccount.movements.length - 1);
        if (requestedLoan > 0) {
          labelLoanMessage.textContent = 'Loan granted';
        } else {
          labelLoanMessage.textContent = 'Thank you for your payment';
        }
        const messageTimeout = setTimeout(clearLoanMessage, 3000);
        inputLoanAmount.value = '';
        updateUI(currentAccount);
        if (logoutTimer) clearInterval(logoutTimer);
        logoutTimer = startLogoutTimer();
      },
      requestedLoan < 0 ? 0 : 5000,
      currentAccount,
      requestedLoan
    );
  } else {
    labelLoanMessage.classList.add('error');
    if (requestedLoan > 0)
      labelLoanMessage.textContent = `Sorry, ${currentAccount.maxLoan} is your limit`;
    else
      labelLoanMessage.textContent = `Your current debt is only ${currentAccount.loan}`;
    setTimeout(clearLoanMessage, 2000);
    inputLoanAmount.value = '';
    updateUI(currentAccount);
  }
  if (logoutTimer) clearInterval(logoutTimer);
  logoutTimer = startLogoutTimer();
});

btnSort.addEventListener('click', function (e) {
  //prevent form from submitting
  e.preventDefault();
  displayMovements(currentAccount, !sorted);
  sorted = !sorted;
});
/////////////////////////////////////////////////
/////////////////////////////////////////////////
// LECTURES

// // NUMBERS - there is one basic Floating Point numeric type stored in binary, nto base 10
// console.log(23 === 23.0); // are the same
// console.log(0.1 + 0.2); // weird rounding issue
// console.log(0.1 + 0.2 === 0.3); /// false due to the lack of precision

// //Conversion
// console.log(Number('23'));
// console.log(+'23');

// //Parsing
// // second parameter is the base system
// console.log(Number.parseInt('30px', 10)); // 30
// console.log(Number.parseInt('1110px', 10)); // 1110
// console.log(Number.parseInt('1110px', 2)); // 14
// console.log(Number.parseInt('AAAA', 16)); // 43690
// console.log(Number.parseInt('e30px', 10)); // NaN

// console.log(Number.parseInt('2.5rem')); //2
// console.log(Number.parseFloat('2.5rem')); //2.5

// // NaN is misleading
// console.log(Number.isNaN(20)); //false
// console.log(Number.isNaN('20')); //false - implicit conversion
// console.log(Number.isNaN(+'20X')); //true
// console.log(Number.isNaN(23 / 0)); //false (number=Infinity)
// console.log(Number.isNaN(0 / 0)); //true

// // Best way to check if value is really a number
// console.log(Number.isFinite(20)); //true
// console.log(Number.isFinite('20')); //false
// console.log(Number.isFinite(+'20X')); //false
// console.log(Number.isFinite(23 / 0)); //false
// console.log(Number.isFinite(0 / 0)); //false

// console.log(Number.isInteger(23)); //true
// console.log(Number.isInteger(23.0)); //true
// console.log(Number.isInteger(23.01)); //false
// console.log(Number.isInteger(23 / 0)); //false

// console.log(Math.sqrt(25)); //5
// console.log(25 ** (1 / 2)); //5
// console.log(8 ** (1 / 3)); //2

// console.log(Math.max(5, 18, 23, 11, 2)); //23
// console.log(Math.max(5, 18, '23', 11, 2)); //23
// console.log(Math.max(5, 18, '23px', 11, 2)); //NaN

// console.log(Math.min(5, 18, 23, 11, 2)); //2

// console.log(Math.PI);
// console.log(Math.PI * Number.parseFloat('10px') ** 2); //area of circle with radius 10px (PI*r2)

// console.log(Math.trunc(Math.random() * 6) + 1);

// const randomInt = (min, max) =>
//   Math.trunc(Math.random() * (max - min + 1)) + min;

// console.log(randomInt(10, 20));

// console.log('---trunc'); // removes decimals
// console.log(Math.trunc(23.3));
// console.log('---round');
// console.log(Math.round(23.3));
// console.log(Math.round(23.9));
// console.log('---ceil');
// console.log(Math.ceil(23.3));
// console.log(Math.ceil(23.9));
// console.log('---floor'); // rounds down, works different from trunc when numbers are negative
// console.log(Math.floor(23.3));
// console.log(Math.floor(23.9));

// console.log('---trunc x floor with negatives');
// console.log(Math.trunc(-23.3)); //-23
// console.log(Math.floor(-23.3)); //-24

// //toFixed() returns a string
// console.log((2.7123).toFixed(0));
// console.log((2.7123).toFixed(2));
// console.log((2.7123).toFixed(3));
// console.log(+(2.7123).toFixed(2));

// // REMAINDER operator
// console.log(5 % 2);
// console.log(5 / 2);
// console.log(8 % 3);
// console.log(8 / 3);

// //Even
// console.log(6 % 2);

// //Odd
// console.log(7 % 2);

// const isEven = (n) => n % 2 === 0;
// console.log(isEven(8));
// console.log(isEven(23));
// console.log(isEven(514));

// labelBalance.addEventListener('click', function () {
//   [...document.querySelectorAll('.movements__row')].forEach(function (row, i) {
//     if (i % 2 === 0) row.style.backgroundColor = 'grey';
//     if (i % 2 === 1) row.style.backgroundColor = 'lightgrey';
//   });
// });

// //Numeric seprator = use "_" to separate numbers in the code
// const diameter = 287_460_000_000;
// console.log(diameter);

// //BigInt - ES2020
// //largest int number in Javascript
// console.log(2 ** 53 - 1);
// console.log(Number.MAX_SAFE_INTEGER);
// console.log(2 ** 53 + 1);
// console.log(2 ** 53 + 2);
// console.log(2 ** 53 + 3);
// console.log(2 ** 53 + 4);

// console.log(48384302483420438234008394839483204n);
// console.log(BigInt(48384302483420438234008394839483204)); // not precise as JS has to store the number first - then convert to BigInt

// //Operations
// console.log(112341123412342340000n * 112341231234123440000n);

// const huge = 998112349569567909978612340987612340976n;
// const num = 23;
// // console.log(huge * num); // error
// console.log(huge * BigInt(num));

// console.log(20n > 15);
// console.log(20n === 20); //false (no type coercion)
// console.log(20n == 20); //true (type coercion)
// console.log(typeof 20n); //BigInt
// console.log(20n == '20'); //true (type coercion)

// console.log(huge + ' is REALLY big!!!');

// //Divisions
// console.log(11n / 3n);
// 3n;
// console.log(10 / 3);
// 3.3333333;

// DATES AND TIMES

// const now = new Date();
// console.log(now);
// console.log(new Date('Jul 14 2024 14:48:12'));
// console.log(new Date('December 25, 2024'));

// console.log(new Date(account1.movementsDates[0]));
// // Month is Zero-based, so 10 is November
// console.log(new Date(2037, 10, 19, 15, 23, 5));

// console.log(new Date(0));
// console.log(new Date(3 * 24 * 60 * 60 * 1000));

// const future = new Date(2037, 10, 19, 15, 23, 5);
// console.log(future);

// console.log(future.getFullYear());
// console.log(future.getMonth());
// console.log(future.getDate());
// console.log(future.getDay());
// console.log(future.getHours());
// console.log(future.getMinutes());
// console.log(future.getSeconds());
// console.log(future.getSeconds());
// console.log(future.toISOString());
// console.log(future.getTime());

// console.log(new Date(future.getTime()));
// console.log(Date.now());
// future.setFullYear(2040);
// console.log(future);

// const future = new Date(2037, 10, 19, 15, 23, 5);
// console.log(+future);

// const calcDaysPassed = (date1, date2) =>
//   (date2 - date1) / (1000 * 60 * 60 * 24);

// const days1 = calcDaysPassed(new Date(2037, 3, 14), new Date(2037, 3, 24));
// console.log(days1);

// // Free Library for dealing with dates = Moment.js
// // https://momentjs.com/

// const num = 98712345.2345;

// const options = {
//   style: 'currency',
//   // unit: 'celsius',
//   currency: 'EUR',
//   // useGrouping: false,
// };

// console.log('US: ', new Intl.NumberFormat('en-US', options).format(num));
// console.log('Germany: ', new Intl.NumberFormat('de-DE', options).format(num));
// console.log('Brazil: ', new Intl.NumberFormat('pt-BR', options).format(num));
// console.log('UK: ', new Intl.NumberFormat('en-GB', options).format(num));

// const ingredients = ['olives', 'cheese'];
// const pizzaTimer = setTimeout(
//   (ing1, ing2) => console.log(`Here is your pizza with ${ing1}, ${ing2} 🍕`),
//   3000,
//   ...ingredients
// );
// console.log('Waiting...');
// if (ingredients.includes('spinach')) clearTimeout(pizzaTimer);

// setInterval(function () {
//   const now = new Date();
//   console.log(now);
// }, 1000);
